// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttProjects from "./projects";

import PendingComponent from "../../components/PendingComponent";
import { isMeaningfulGigsRole } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const askPunttProjectsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/projects",
  beforeLoad() {
    if (!isMeaningfulGigsRole()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttProjects,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
